import React from "react";

import { Inputs, Row, Field } from "2g-form";
import { required } from "2g-validators-common";

import { Date as DateRenderer } from "b2b/renderers";
import { getCurrentMonday } from "b2b/utils/date";
import { ACZadostiStav } from "b2b/components/autocompletes";

import useMessages from "./i18n/useMessages";

const validatorRequired = required();
export function ZadostiHistorieFilterContent() {
  const messages = useMessages();
  const datumOd = getCurrentMonday();
  const datumDo = new Date(datumOd);
  datumDo.setDate(datumDo.getDate() + 13);

  return (
    <>
      <Row>
        <Field
          component={Inputs.DateTimePicker}
          path="datumOd"
          label={messages.filterLabelDateFrom()}
          milliseconds
          date
          defaultValue={datumOd.getTime()}
          descriptionRenderer={DateRenderer}
          required
          validators={validatorRequired}
        />
      </Row>
      <Row>
        <Field
          component={Inputs.DateTimePicker}
          path="datumDo"
          label={messages.filterLabelDateTo()}
          milliseconds
          date
          defaultValue={datumDo.getTime()}
          descriptionRenderer={DateRenderer}
          required
          validators={validatorRequired}
        />
      </Row>
      <Row>
        <ACZadostiStav
          path="stav"
          label={messages.filterLabelRequestStatus()}
        />
      </Row>
    </>
  );
}

ZadostiHistorieFilterContent.propTypes = {};

export default React.memo(ZadostiHistorieFilterContent);
